export const environment = {
  production: true,
  apiUrl: 'https://hmax-order-staging-860539388441.southamerica-east1.run.app/api',
  firebase: {
    apiKey: 'AIzaSyDQqGK38wD8fpp7axfdLO-2Wk2T3TWj8HA',
    authDomain: 'hmax-order-dev.firebaseapp.com',
    projectId: 'hmax-order-dev',
    storageBucket: 'hmax-order-dev.firebasestorage.app',
    messagingSenderId: '860539388441',
    appId: '1:860539388441:web:1a9189e7866c72e8e4e088',
  },
  plugins: [],
};
